// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Textarea_wrap__Lnb_J","textarea":"Textarea_textarea__GnGzt","label":"Textarea_label__cWKmu"};